import { $themeBreakpoints, $themeColors } from '@themeConfig'


export const useAppStore = defineStore('app',() => {
  const windowWidth =  ref(0);
  const shallShowOverlay = ref(false);
  const version = ref(String(localStorage.getItem('version-app'))| null);
  const showComposeEmail = ref(false);

  const currentBreakPoint = computed(() => {
    if (windowWidth.value >= $themeBreakpoints.xxl) return "xxl";
    if (windowWidth.value >= $themeBreakpoints.xl) return 'xl'
    if (windowWidth.value >= $themeBreakpoints.lg) return 'lg'
    if (windowWidth.value >= $themeBreakpoints.md) return 'md'
    if (windowWidth.value >= $themeBreakpoints.sm) return 'sm'
    return 'xs'
  });

  const isMenorQue = (breakpoint = 'md') => {
    let tam_breakpoint = $themeBreakpoints[breakpoint];
    return windowWidth.value <= tam_breakpoint;
  };

  const isScreenMovil = computed(() => {
    return windowWidth.value <= $themeBreakpoints.sm;
  });

  const colorsTheme = computed( () => {
    return $themeColors;
  })

  const anchoSidebar = computed(() => {
    
    if(windowWidth.value <= 576) {
      return '97%';
    } else if(windowWidth.value <= 786){
      return '90%';
    }else if(windowWidth.value <= 992){
      return '70%';
    }else if(windowWidth.value <= 1200){
      return '70%';
    }else {
      return '1080px';
    };

  });


  const UPDATE_WINDOW_WIDTH = (val)  => {
    windowWidth.value = val
  }

  const TOGGLE_OVERLAY = (val) => {
    shallShowOverlay.value = val !== undefined ? val : !shallShowOverlay.value
  }

  const setVersion = (version) => {
    localStorage.setItem('version-app',version)
    version.value = version
  }

  const toggleShowComposeEmail = () => {
    showComposeEmail.value = !showComposeEmail.value
  };

  return {
    windowWidth,
    shallShowOverlay,
    version,
    showComposeEmail,
    currentBreakPoint,
    anchoSidebar,
    isScreenMovil,
    colorsTheme,
    UPDATE_WINDOW_WIDTH,
    TOGGLE_OVERLAY,
    setVersion,
    toggleShowComposeEmail,
    isMenorQue,
  };
});

export default useAppStore;